import axios from "axios";

// API base URL resolution:
//  1. In the browser: ALWAYS use same-origin `/api` — nginx routes /api/* to
//     the backend on every subdomain (loans., switch., www., main), so a stale
//     REACT_APP_BACKEND_URL secret (e.g. pointing to a dead old domain) can't
//     break the app. This fixes the class of bug where the secret was baked
//     into a Docker build and later got out of sync with the actual host.
//  2. In non-browser contexts (SSR/tests): honor REACT_APP_BACKEND_URL, else
//     fall back to relative `/api`.
const isBrowser = typeof window !== "undefined" && !!window.location;
export const API = isBrowser
  ? "/api"
  : `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiErrorMessage(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
}
